import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {

    links = [
        {
            name: 'import stepper',
            path: 'import-stepper'
        },
        {
            name: 'import components',
            path: 'import'
        },
        {
            name: 'export stepper',
            path: 'export-stepper'
        },
        {
            name: 'export components',
            path: 'export'
        },        {
            name: 'navigation',
            path: 'navigation'
        }
    ];

    constructor(public readonly  translate: TranslateService) {
    }

    public changeLanguage(lng: string) {
        this.translate.use(lng.toLowerCase());
    }
}
